import { colors } from 'Constants/Colors';
import MuiDrawer from '@mui/material/Drawer';
import { makeStyles } from '@mui/styles';
import '@fontsource/metropolis';
import { styled } from '@mui/material/styles';

const drawerWidth = 240;
const openedMixin = theme => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = theme => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(9)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: prop => prop !== 'open',
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
}));

const useStyles = makeStyles({
  MuiDrawer: {
    backgroundColor: `${colors.BLACK} !important`,
  },
  listItem: {
    '& .MuiTypography-root': {
      color: 'white',
      fontFamily: 'var(--app-font)',
    },
    '& .MuiListItemIcon-root': {
      display: 'flex',
      justifyContent: 'center',
      color: colors.GREEN,
    },
    '&:hover, &:focus': {
      background: `linear-gradient(270deg, rgba(0, 0, 0, 0) 0%, ${colors.GREEN_SHINING} 100%)`,
      '& .MuiTypography-root': {
        fontWeight: 'bold',
      },
      '& .MuiListItemIcon-root': {
        color: colors.WHITE,
      },
    },
  },
  selectedItem: {
    background: `linear-gradient(270deg, rgba(0, 0, 0, 0) 0%, ${colors.GREEN_SHINING} 100%)`,
    borderRight: `3px solid ${colors.GREEN} !important`,
    '& .MuiTypography-root': {
      fontWeight: 'bold',
      color: colors.WHITE,
      fontFamily: 'var(--app-font)',
    },
    '& .MuiListItemIcon-root': {
      display: 'flex',
      justifyContent: 'center',
      color: colors.WHITE,
    },
    '&:hover, &:focus': {
      background: `linear-gradient(270deg, rgba(0, 0, 0, 0) 0%, ${colors.GREEN_SHINING} 100%)`,
      '& .MuiTypography-root': {
        fontWeight: 'bold',
      },
      '& .MuiListItemIcon-root': {
        color: colors.WHITE,
      },
    },
  },
  imageStyleClosed: {
    width: '60%',
    margin: 'auto',
    marginTop: '15%',
    marginBottom: '15%',
  },
  imageStyleOpen: {
    margin: 'auto',
    marginTop: '10%',
    marginBottom: '5%',
    width: '100%',
  },
  sideBarArrow: {
    marginTop: '30px !important',
    '& .MuiListItemIcon-root': {
      display: 'flex',
      justifyContent: 'center',
      color: colors.GREEN,
    },
    '&:hover': {
      background: `linear-gradient(270deg, rgba(0, 0, 0, 0) 0%, ${colors.GREEN_SHINING} 100%)`,
      '& .MuiTypography-root': {
        fontWeight: 'bold',
      },
      '& .MuiListItemIcon-root': {
        color: colors.WHITE,
      },
    },
    '& .MuiTypography-root': {
      color: colors.WHITE,
      fontFamily: 'var(--app-font)',
    },
  },
});

export default {
  Drawer,
  DrawerHeader,
  useStyles,
};
